import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import Data from '../../../Data/Data.json'
import Utilis from '../../../Models/Utilis';
import DistantProfils from '../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import { Typography } from '@mui/material';
import useGroupeData from '../../../Hooks/useGroupeData';

//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const Groupe = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  // Custom hook for group data management
  const { data: groupeData, setModules, setPlanCps, setGroupInfo, resetData, isLoading: dataLoading, error: dataError } = useGroupeData();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [isConsultMode, setIsConsultMode] = useState(false)
  const [isAddMode, setIsAddMode] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
    setIsConsultMode(false)
    setIsAddMode(false)
    setIsEditMode(false)
  }

  const SetStart = () => {
    setSbmit("add")
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    setIsAddMode(true)
    setIsConsultMode(false)
    setIsEditMode(false)
    form.resetFields()
    form.setFieldValue("niveau", 900)
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields()
    resetData()
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton()
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
    setIsConsultMode(true)
    setIsAddMode(false)
    setIsEditMode(false)
  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setIsEditMode(true)
    setIsConsultMode(false)
    setIsAddMode(false)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Gestion de groupe
        </span>
      ),
      children: <Tab1 
        form={form} 
        disabled={!ajoutActve} 
        groupeData={groupeData} 
        setModules={setModules} 
        setPlanCps={setPlanCps}
        isConsultMode={isConsultMode}
        isAddMode={isAddMode}
        isEditMode={isEditMode}
      />,
    }
  ];

  const onFinish = (values: any) => {
    console.log(values)
    if (sbmit == "add") {
      console.log(groupeData.modules)
      SweetAlert.fire({
        title: "Enregistrement de groupe",
        text: "Voulez-vous enregistrer le groupe " + values.codgroup + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //let group = profilsDistant.find(()=>)

          values = { "utilis": user.coduti, ...values, "libelle": values.lib_codgroup, "modules": groupeData.modules, "plancps": groupeData.planCps }


          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(values)));

          let data = Crypter.encrypt(JSON.stringify(values));

          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateGroup,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  let code = values.codgroup
                  form.resetFields()
                  resetData()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })

                  initialiazeButton()

                  setSbmit("")
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });

        }
      })
    }
    if (sbmit == "update") {
      //console.log(values)
      SweetAlert.fire({
        title: "Modification du groupe",
        text: "Voulez-vous modifier le groupe " + values.codgroup + " ?",
        showCancelButton: true,
        color: "#116599",
        confirmButtonText: "Yes",
        confirmButtonColor: "#116599",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          let profilsDistant;
          let codeGroup: String = "";

          //alert(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.groupModule)+""))
          values = { "utilis": user.coduti, ...values, "libelle": values.lib_codgroup, "modules": groupeData.modules, "plancps": groupeData.planCps }


          console.log('Received values of form: ', values);

          let data = Crypter.encrypt(JSON.stringify(values));

          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.UpdateGroup,
            headers: {
              // 'CypherGroup': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  let code = values.codgroup
                  form.resetFields()
                  resetData()
                  setIsSubmit(false)
                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })

                  initialiazeButton()

                  setSbmit("")
                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });

        }
      })

    }


  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function consult() {
    let data = Crypter.encrypt(form.getFieldValue("codgroup"));
    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AfficheGroup,
        headers: {
          'CypherGroupCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              form.setFieldValue('codgroup', res.Result.Table[0].CODGROUP)
              form.setFieldValue('lib_codgroup', res.Result.Table[0].LIBELLE)
              form.setFieldValue('niveau', res.Result.Table[0].NIVEAU)
              
              // Activer le mode consultation
              setIsConsultMode(true)
              setIsAddMode(false)
              setIsEditMode(false)
              cunsultButton()
              
              console.log(res.Result.Table2)
              
              // Mapper les modules correctement
              const moduleCodes = res.Result.Table1.map((item: any) => item.CODMENU)
              setModules(moduleCodes)
              
              // Mapper les plans comptables
              const planCpCodes = res.Result.Table2.map((item: any) => item.IDPLAN)
              setPlanCps(planCpCodes)
              
              // Mettre à jour les informations du groupe
              setGroupInfo({
                codgroup: res.Result.Table[0].CODGROUP,
                lib_codgroup: res.Result.Table[0].LIBELLE,
                niveau: res.Result.Table[0].NIVEAU
              })
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
  }

  function consultHabilitation() {
    let data = Crypter.encrypt(form.getFieldValue("codgroup"));
    if (data.length != 0) {
      initialiazeButton()
      setLoading(true)
      form.resetFields()
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.AfficheGroup,
        headers: {
          'CypherGroupCode': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };
      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
             // console.log(res)
             // alert(res.Result.Table[0].CODGROUP)
              //form.setFieldsValue(res.Result.Table[0].CODGROUP);
              form.setFieldValue('codgroup', res.Result.Table[0].CODGROUP)
              form.setFieldValue('lib_codgroup', res.Result.Table[0].LIBELLE)
              form.setFieldValue('niveau', res.Result.Table[0].NIVEAU)
              cunsultButton()
              console.log(res.Result.Table2)
              setModules(res.Result.Table1.map((item: any) => item.CODMENU))
              setPlanCps(res.Result.Table2.map((item: any) => item.IDPLAN))
              setGroupInfo({
                codgroup: res.Result.Table[0].CODGROUP,
                lib_codgroup: res.Result.Table[0].LIBELLE,
                niveau: res.Result.Table[0].NIVEAU
              })
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" })
        });
    }
  }
  function modif() {
    modifButton()

  }
  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>GESTION DE GROUPE UTILISATEUR </b></Typography>
      <Spin spinning={loading || dataLoading} size='large' style={{ color: '#116599' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"#116599"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>

                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>

                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Imprimer
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={false} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default Groupe;